@if (safeHtml) {
  <p [innerHTML]="safeHtml"></p>
}
